export interface FilterValue {
	id: string,
	type: 'match' | 'flag';
	title: string;
	key: string;
	value: string | boolean;
}

export class FilterValue {
	constructor(raw: string) {
		const filter: FilterValue = JSON.parse(raw);
		this.id = filter.id;
		this.type = filter.type;
		this.title = filter.title;
		this.key = filter.key;
		this.value = filter.value;
	};

	static isEqual(a: FilterValue, b: FilterValue): boolean {
		return Object.keys(a).every(key => b?.[key]===a[key]);
	}
}

export default class Filter {
	filters: Record<string, FilterValue>;
	activeFilters: string[];

	constructor() {
		this.filters = {};
		this.activeFilters = [];
	}

	init(filters: FilterValue[], activeFilters: string[]): void {
		this.filters = Object.fromEntries(filters.map((filter) => [filter.id, filter]));
		this.activeFilters = activeFilters;
	}

	getIDs(): string[] {
		return this.activeFilters;
	}

	getValues(): FilterValue[] {
		return this.activeFilters.map(id => this.filters[id]);
	}

	add(filters: string[]): number {
		this.activeFilters.push(...filters);
		return this.activeFilters.length - 1;
	}

	remove(filters: string[]): void {
		this.activeFilters = this.activeFilters.filter(
			(f: string) => !filters.some(id => FilterValue.isEqual(this.filters[f], this.filters[id]))
		);
	}

	toggle(filters: string[]): boolean[] {
		const add: string[] = [];
		const remove: string[] = [];
		filters.forEach(filter => {
			if (this.activeFilters.some(id => FilterValue.isEqual(this.filters[filter], this.filters[id]))) {
				remove.push(filter);
			} else {
				add.push(filter);
			}
		});
		this.add(add);
		this.remove(remove);
		return filters.map(f => add.includes(f));
	}

	clear(): void {
		this.activeFilters = [];
	}

	set(filters: string[]): void {
		this.activeFilters = filters;
	}
}